export const FOCUS = {
  INBOX: {
    id: 'inbox',
    title: 'Inbox'
  },
  TODAY: {
    id: 'today',
    title: 'Now'
  },
  NEXT: {
    id: 'next',
    title: 'Next'
  },
  SOMEDAY: {
    id: 'somedayMaybe',
    title: 'Someday Maybe'
  },
  WAITING: {
    id: 'waitingFor',
    title: 'Waiting For'
  },
  SCHEDULED: {
    id: 'tickler',
    title: 'Scheduled'
  },
  REPEATING: {
    id: 'repeat',
    title: 'Repeating'
  },
  NOTES: {
    id: 'notes',
    title: 'Notes'
  },
  TRASH: {
    id: 'trash',
    title: 'Trash'
  }
}

export const SELECTABLE_FOCUS = [
  FOCUS.INBOX,
  FOCUS.TODAY,
  FOCUS.NEXT,
  FOCUS.SOMEDAY,
  FOCUS.WAITING,
  FOCUS.NOTES,
  FOCUS.SCHEDULED
]

export const VIEW_ALL_FOCUS = [
  FOCUS.INBOX,
  FOCUS.TODAY,
  FOCUS.NEXT,
  FOCUS.SOMEDAY,
  FOCUS.WAITING,
  FOCUS.NOTES,
  FOCUS.SCHEDULED,
  FOCUS.REPEATING
]

export const DELETE_PERMANENTLY_FOCUS = [FOCUS.TRASH.id, FOCUS.REPEATING.id]

export const getFocusTitle = id => {
  const found = Object.entries(FOCUS).find(([key, value]) => value.id === id)
  if (found) {
    return found[1].title
  }
  return id
}

export const isValidList = id => {
  return (
    Object.entries(FOCUS).findIndex(([key, value]) => value.id === id) !== -1
  )
}
